import React, { useState } from 'react';
import { Document, Page, pdfjs } from "react-pdf";
import { Button } from '@material-ui/core';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const PdfRender = ({ step, ...props }) => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    function handlePageChange() {
        return (
            numPages > 1 ?
                <> { pageNumber < numPages ?
                    <Button variant="contained" color="primary" className='float-right' onClick={() => {
                        setPageNumber(pageNumber + 1);
                    }}>Avan�ar p�gina</Button>
                    : ''}
                    { pageNumber > 1 ?
                        <Button variant="contained" color="primary" className='float-left' onClick={() => {
                            setPageNumber(pageNumber - 1);
                        }}>Voltar p�gina</Button>
                        : ''} </>
                : '')
    }

    return (
        <div>
            <Document
                file={step.content}
                onLoadSuccess={onDocumentLoadSuccess}
            >
                <Page pageNumber={pageNumber} />
            </Document>
            <p>P�gina {pageNumber} de {numPages}</p>
            { handlePageChange()}
        </div>
    );
}